import { FaArrowUp } from 'react-icons/fa'

import styles from '../styles/ScrollTop.module.css'

export default function ScrollTop() {
  const scrollTop = () =>{
   window.scrollTo({top: 0, behavior: 'smooth'});
 };

  return(
    <div onClick={scrollTop} className={styles.scrollTop}>
        <FaArrowUp/>
    </div>
  )
}
